export const getQuestionStats = (questionsData = []) => {
  return {
    notVisited: questionsData.filter((q) => q.status === "unvisited").length,
    marked: questionsData.filter((q) => q.status === "marked").length,
    answered: questionsData.filter((q) => q.status === "answered").length,
    answeredMarked: questionsData.filter((q) => q.status === "answered_marked")
      .length,
    notAnswered: questionsData.filter((q) => q.status === "unanswered").length,
    current: questionsData.filter((q) => q.status === "current").length,
  };
};
